import React, { useEffect, useMemo, useState } from "react";
import { catalogApi } from "../../api/auctiongate.js";

/** Full browser of auctionFee.json with auction + fee-level filter. */
const TABS = [
  { value: "fee1low", label: "Low" },
  { value: "fee1high", label: "High" },
  { value: "fee2", label: "Tier 2" },
];

export default function FeeBrowser() {
  const [fee, setFee] = useState(null);
  const [err, setErr] = useState(null);
  const [auction, setAuction] = useState("copart");
  const [level, setLevel] = useState("fee1high");

  useEffect(() => {
    catalogApi.fee().then(setFee, (e) => setErr(e?.message));
  }, []);

  const rows = useMemo(() => {
    const t = fee?.[auction]?.[level];
    return Array.isArray(t) ? t : [];
  }, [fee, auction, level]);

  return (
    <div className="card">
      <div className="card__title">
        Auction fee table
        <span className="badge">{auction} · {level}</span>
      </div>
      {err && <div className="login-error">{err}</div>}
      <div className="row" style={{ marginBottom: 10 }}>
        <select value={auction} onChange={(e) => setAuction(e.target.value)} style={input}>
          <option value="copart">Copart</option>
          <option value="iaai">IAAI</option>
        </select>
        <select value={level} onChange={(e) => setLevel(e.target.value)} style={input}>
          {TABS.map((t) => (
            <option key={t.value} value={t.value}>
              {t.label}
            </option>
          ))}
        </select>
      </div>
      {!fee && !err && <span className="loader" />}
      {fee && (
        <div style={{ maxHeight: 280, overflow: "auto" }}>
          <div style={head}>
            <span>≤ point</span>
            <span>Fee</span>
            <span>Description</span>
          </div>
          {rows.map((r, i) => (
            <div key={i} style={row}>
              <span>${r.point}</span>
              <span style={{ fontWeight: 600 }}>${r.price}</span>
              <span className="muted">{r.description}</span>
            </div>
          ))}
          {!rows.length && <div className="placeholder-panel">No data.</div>}
        </div>
      )}
    </div>
  );
}

const input = {
  padding: "7px 10px",
  border: "1px solid var(--color-border-input)",
  borderRadius: 8,
  fontSize: 13,
  background: "#fff",
};
const head = {
  display: "grid",
  gridTemplateColumns: ".8fr .8fr 2fr",
  gap: 8,
  padding: "6px 8px",
  fontSize: 12,
  color: "var(--color-text-muted)",
  fontWeight: 600,
  borderBottom: "1px solid var(--color-border)",
  background: "var(--color-bg-card-elevated)",
};
const row = {
  display: "grid",
  gridTemplateColumns: ".8fr .8fr 2fr",
  gap: 8,
  padding: "5px 8px",
  fontSize: 13,
  borderBottom: "1px solid var(--color-border)",
};
